import { useWorkerStats } from 'pages/HomePage/ShiftCard/useWorkerStats'
import { AvatarGroup } from '@workwhile/ui'

interface Props {
  shift: Parameters<typeof useWorkerStats>[0]
}

export const ShiftWorkerAvatars = ({ shift }: Props) => {
  const { totalWorkers } = useWorkerStats(shift)

  return (
    <AvatarGroup
      max={5}
      firstToFront
      users={totalWorkers.map((work) => ({
        userId: work.worker?.id.toString(),
        photoUrl: work.worker?.profilePicUrl,
        name: work.worker?.name,
      }))}
    />
  )
}
